import EditSystemModal from './containers/EditSystemContainer'

export default EditSystemModal
